/**
 *
 * key
 *
 */

 const key = 'bGVhZFNvdXJjZVN0YXR1cw=='

 export default key
 